module.exports = __webpack_public_path__ + "img/consultoria_3-4_1536.5499340f.webp";